import { Metric } from '../../../../dashboard-config/dashboard-config.model';
import {
  expandProductCatalog,
  ProductCatalogEntry,
} from '../../../_shared/dashboard-definition.model';
import { createDashboardRankingDefinition } from './create-dashboard-ranking-definition';
import {
  RankingMetricProfile,
  rankingCompaniesCountProfile,
  rankingCompaniesRevenueProfile,
  rankingEconomicParticipantProfile,
  rankingEmployedProfile,
  rankingGrossValueAddedProfile,
  rankingSelfEmployedProfile,
} from './dashboard-ranking-metric.profile';
import { DashboardRankingShell } from './dashboard-ranking-shell.profile';
import { DashboardRankingDefinition } from './dashboard-ranking.definition';

/**
 * Product catalog for single-column Ranking dashboards.
 * WZ multi-column products live in the multi-column package.
 * Identity is derived in {@link createDashboardRankingDefinition}.
 */

type RankingMetric = Exclude<Metric, Metric.Tourism>;

export const RANKING_PRODUCT_CATALOG: Record<
  RankingMetric,
  ProductCatalogEntry<RankingMetricProfile, DashboardRankingShell>
> = {
  [Metric.CompaniesCount]: {
    metric: rankingCompaniesCountProfile,
    shells: ['states', 'wzClassStates', 'districts', 'subMarkets', 'districtSubMarkets', 'districtWzClasses'],
  },
  [Metric.CompaniesRevenue]: {
    metric: rankingCompaniesRevenueProfile,
    shells: ['states', 'wzClassStates', 'districts', 'subMarkets', 'districtSubMarkets', 'districtWzClasses'],
  },
  [Metric.GrossValueAdded]: {
    metric: rankingGrossValueAddedProfile,
    shells: ['states', 'wzClassStates', 'districts', 'subMarkets', 'districtSubMarkets', 'districtWzClasses'],
  },
  // No districtWzClasses from here on: Kreise × WZ-Klassen is bottom-up only, for Count, Revenue and GVA.
  [Metric.EconomicParticipant]: {
    metric: rankingEconomicParticipantProfile,
    shells: ['states', 'wzClassStates', 'districts', 'subMarkets', 'districtSubMarkets'],
  },
  [Metric.Employed]: {
    metric: rankingEmployedProfile,
    shells: ['states', 'wzClassStates', 'districts', 'subMarkets', 'districtSubMarkets'],
  },
  // Pending datasets: districts (rk__d), wzClassStates (rk__wz), districtSubMarkets (rk__sm_d).
  [Metric.SelfEmployed]: {
    metric: rankingSelfEmployedProfile,
    shells: ['states', 'subMarkets'],
  },
};

/** All single-column ranking product definitions (expanded from the product catalog). */
export const RANKING_DEFINITIONS: DashboardRankingDefinition[] =
  expandProductCatalog(
    Object.values(RANKING_PRODUCT_CATALOG),
    createDashboardRankingDefinition,
  );
